import { useAuthentication } from '@givebacks/api';
import { EarnCTAButton } from 'ui';

import { AddCardModal } from '../../../components/shared/Cards/AddCard/AddCardNew';
import AddCardSuccessModal from '../../../components/shared/Cards/AddCard/AddCardSuccessModal';
import { useAddCardModal } from '../../../components/shared/Cards/AddCard/useAddCardModal';
import { useSelectHasEitherCardTypes } from '../../../hooks/queries/Core/payments';
import useGtmServices from '../../../hooks/useGtmServices';
import { useHandleAddCardClick } from '../../../hooks/useHandleAddCardClick';
import { useNavigateToAuth } from '../../../hooks/useNavigateToAuth/useNavigateToAuth';

const AddCredentialEarnCard = () => {
  const GtmService = useGtmServices();
  const { isAuthenticated } = useAuthentication();
  const { handleAddCardClick } = useHandleAddCardClick();
  const { addCardProps, openAddCardModal, successProps } = useAddCardModal();
  const { handleNavigateToAuth } = useNavigateToAuth();
  const { data: hasPartnerCard } = useSelectHasEitherCardTypes();

  const getStarted = () => {
    handleNavigateToAuth({ page: 'sign-up' });
  };

  const handleClick = () => {
    GtmService.click(
      () => {
        if (!isAuthenticated) return getStarted(); // If someone is not logged in, lets allow this CTA to open to onboarding
        handleAddCardClick(openAddCardModal);
      },
      {
        type: 'button',
        action: 'add_card',
        label: 'Link Your Card',
      }
    );
  };

  if (hasPartnerCard) return null;

  return (
    <>
      <EarnCTAButton type="local" onClick={handleClick} />
      <AddCardModal {...addCardProps} />
      <AddCardSuccessModal {...successProps} />
    </>
  );
};

export { AddCredentialEarnCard };
